import Vue from 'vue';
import { has, is } from 'ramda';
import * as templates from '@/templates/logs';

const isString = is(String);

const renderElement = (createElement, content) => {
  if (Array.isArray(content)) {
    return createElement(
      'div',
      {},
      content.map(temp => {
        if (isString(temp)) {
          return temp;
        }

        return createElement(temp.tag, temp);
      }),
    );
  }

  return createElement('div', content);
};

export const render = content =>
  Vue.extend({
    render: createElement => renderElement(createElement, content),
  });

export const renderLog = log => {
  const activityTemplate = has(log.type, templates)
    ? templates[log.type](log)
    : templates.defaultTemplate(log);

  return render(activityTemplate);
};
